export function toAnalyticsUtcPeriod({ startDate, endDate }, now = new Date()) {
  const start = new Date(`${startDate}T00:00:00.000`);
  const end = new Date(`${endDate}T23:59:59.999`);
  if (!Number.isFinite(start.getTime()) || !Number.isFinite(end.getTime()) || start > end) {
    throw new Error("Invalid analytics period");
  }

  return {
    startDate: start.toISOString(),
    endDate: (startDate === endDate ? now : end).toISOString(),
  };
}
